<template>
  <div class="layout">
    <header>
      <div class="header-box">
        <p class="logo">
          智慧云平台
        </p>
      </div>
    </header>
    <main class="login">
      <img
        src="../../assets/background_logo.png"
        class="background">
      <div class="form">
        <div
          class="title"
          :style="{
            marginBottom: isWeixin ? '34px' : '56px',
          }">
          <span
            :class="{
              active:!isWeixin,
            }"
            @click="switchLoginType(0)">账号密码登录</span>
          <span
            :class="{
              active: isWeixin,
            }"
            @click="switchLoginType(1)">微信登录</span>
        </div>
        <WeiXinLogin v-if="isWeixin"/>
        <template v-else>
          <VerifyModal
            @success="success"
            ref="verifyModal"
          ></VerifyModal>
          <AuthMultipleInput
            ref="username"
            v-model="username"
            type="autoComplete"
            label="手机号码"
            placeholder="手机号码"
            :maxlength="11"
            :search-data="accounts"
            :rule="[
              { required: true, message: `手机号码不能为空`, trigger: `blur` }
            ]"
            @keyup-enter="submit"
          ></AuthMultipleInput>
          <AuthMultipleInput
            ref="password"
            v-model="password"
            type="password"
            label="密码"
            password
            placeholder="密码"
            :maxlength="20"
            :rule="[
              { required: true, message: `密码不能为空`, trigger: `blur` }
            ]"
            @keyup-enter="submit"
          >
          </AuthMultipleInput>
          <div>
            <Button
              @click="submit"
              :loading="loading">
              登录
            </Button>
            <div class="form-bottom">
              <router-link
                class="forgot-link"
                :to="{name: `findPwd`}">
                忘记密码
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </main>
  </div>
</template>

<script>
import AuthMultipleInput from '@/components/auth-multiple-input.vue';
import pattern from '@/util/pattern';
import {login, loginCaptchaRequired} from '@/service';
import {getCookieInfo, encrypt, setCookieInfo, getHistoryAccounts, addHistoryAccount} from '@/util';
import {validationFormat} from '../../util/password';
import WeiXinLogin from './weixin-login.vue';
import VerifyModal from '../components/verify-modal';

export default {
  name: 'Login',
  components: {AuthMultipleInput, WeiXinLogin, VerifyModal},
  data() {
    return {
      pattern,
      loading: false,
      accounts: getHistoryAccounts(),
      username: '',
      password: '',
      isWeixin: false,
    };
  },

  mounted() {
    const {token} = getCookieInfo();
    if (token) {
      this.$store.dispatch('user/init').then(() => {
        this.$router.push(`/`);
      });
    }
  },

  methods: {
    switchLoginType(type) {
      this.isWeixin = !!type;
    },
    submit() {
      Promise.all([
        this.$refs['username'].isValid(),
        this.$refs['password'].isValid(),
      ]).then(([v1, v2]) => {
        if (v1 && v2) {
          const username = this.$refs['username'].getOriginValue();
          const password = this.$refs['password'].getOriginValue();
          if (!validationFormat(password)) {
            return this.$Modal.info({
              title: '提示',
              content: '您的密码安全级别过低，请通过【忘记密码】重置密码。',
            });
          }
          loginCaptchaRequired({username}).then(({data})=>{
            if (!data) return this.login();
            else this.$refs['verifyModal'].open();
          });
        }
      });
    },
    success(captchaVerification) {
      this.login(captchaVerification);
    },
    login(captchaVerification) {
      const username = this.$refs['username'].getOriginValue();
      const password = this.$refs['password'].getOriginValue();
      this.loading = true;
      login({
        username,
        password: encrypt(password),
        deviceId: this.$store.getters['system/deviceId'],
        corpLogin: this.corpLogin,
        captchaVerification,
        // eslint-disable-next-line camelcase
      }).then(({access_token, expires_in}) => {
        this.$Message.success('登录成功');
        setCookieInfo('123cx@token', access_token, expires_in);
        setCookieInfo('login-time', new Date().getTime(), expires_in);
        addHistoryAccount(username);
        this.$router.push(`/`);
      }, ({response: {data}}) => {
        this.$Message.error(data.error_description);
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100vh;
  min-width: 1400px;
  background: #ffffff;
  overflow: hidden;
  header {
    display: flex;
    align-items: center;
    height: 64px;
    width: 100%;
    margin-left: 28px;
    .header-box {
      display: flex;
      flex-direction: column;
      width: 136px;
      text-align-last:justify;
      text-align:justify;
      text-justify:distribute-all-lines;
      .logo {
        font-size: 26px;
        color: #3f3f3f;
      }
      .path {
        font-size: 10px;
        color: #979797;
        font-weight: 600;
      }
    }
  }
  .login {
    position: relative;
    display: flex;
    align-items: center;
    height: calc(100vh - 136px);
    min-height: 600px;
    width: 100%;
    background: url('../../assets/login_background.jpg') no-repeat;
    background-size:100% 100%;
    .background {
      position: absolute;
      right: 56%;
      width:464px;
      height: 436px;
      margin-bottom: 80px;
    }
    .form {
      position: absolute;
      left: 56%;
      box-sizing: border-box;
      width:370px;
      height: 408px;
      padding: 30px 48px 50px;
      margin-bottom: 80px;
      border-radius: 6px;
      box-shadow: 0 2px 14px 0 rgba(0,0,0,0.17);
      background: #ffffff;
      .title {
        font-size: 20px;
        margin-bottom: 56px;
        span {
          position: relative;
          cursor: pointer;
          &.active{
            color: #1890FF;
            &:before {
              position: absolute;
              bottom: -6px;
              content: '';
              width: 100%;
              height: 3px;
              background: #1890ff;
              border-radius: 2px;
            }
          }
          &+span{
            margin-left: 36px;
          }
        }
      }
      button {
        height: 38px;
        background: linear-gradient(
          270deg,
          rgba(24,144,255,1) 0%,
          rgba(24,144,255,1) 100%
        );
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        border: 0;
        outline: 0;
        width: 100%;
        margin-top: 8px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      .form-bottom {
        margin-top: 12px;
        text-align: right;
        .forgot-link {
          color: #1890FF;
          text-decoration: none;
        }
      }
    }
  }
  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 72px;
    width: 100%;
    font-size: 11px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
